/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useLocation, Outlet } from "react-router-dom";
import toast from "react-hot-toast";
import { AuthContext } from "../context";
import { BackIcon, MenuIcon, UserMenuIcon } from "../assets/icons";
import { Logo, WaveImage } from "../assets/img";
import { classNames } from "../utils";
import { MENU_ADMIN } from "./menu";
import ConfirmModal from "../components/confirm-modal";

const Layout = () => {
  const userMenuRef = useRef();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [navigation, setNavigation] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const getUserMenu = () => {
    if (!user) return;
    const breadcrumbs = [];
    const searchSubmodules = (item) => {
      if (item?.href)
        breadcrumbs.push({
          name: item?.breadcumb || item.name,
          href: item.href,
        });

      if (item?.modules?.length) {
        item.modules.forEach((subItem) => searchSubmodules(subItem));
      }
      if (item?.nested?.length) {
        item.nested.forEach((subItem) => searchSubmodules(subItem));
      }
    };
    const filteredMenu = MENU_ADMIN || [];
    filteredMenu.forEach((item) => searchSubmodules(item));
    setNavigation(filteredMenu);
    setBreadcrumbs(breadcrumbs);
  };

  const routeName =
    breadcrumbs.find((x) => {
      const currentParts = location.pathname.split("/");
      const pathParts = x?.href?.split("/") || [];
      if (currentParts.length !== pathParts.length) return false;
      return pathParts.every((item, i) => {
        const _current = currentParts[i];
        return pathParts[i].includes(":") ? true : item === _current;
      });
    })?.name || "";

  const toggleSidebar = () => {
    const items = document.getElementsByClassName("desk-sidebar");
    for (let key = 0; key < items.length; key++) {
      items.item(key).classList.toggle("open");
    }
  };

  useEffect(() => {
    getUserMenu();
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setIsUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div id="layout" className="relative">
      <div className="desk-sidebar desk-sidebar__header z-[80] relative">
        <div className="sidebar-logo z-[90] bg-white border-r border-gray-200">
          <div className="sidebar-logo__wrapper bg-white flex justify-center items-center h-full w-full">
            <img src={Logo} className="h-11 object-contain" alt="Logo" />
          </div>
        </div>

        <div className="desk-headerbar !bg-[#1D3B8B] relative !h-20 !px-4 lg:!px-8 border-none z-[80]">
          {/* Contenedor aislado para recortar la ola sin cortar el menú desplegable */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img
              src={WaveImage}
              className="absolute -top-[30px] left-0 right-0 w-full h-[172px] object-cover opacity-90"
              alt=""
            />
          </div>

          <div className="flex w-full h-full items-center justify-between z-10 relative">
            <div className="flex items-center gap-3 md:gap-5 z-[70] relative">
              <div
                id="header-goback"
                className="hidden cursor-pointer bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-colors"
                onClick={() => navigate(-1)}
              >
                <BackIcon size={24} className="text-white" title="Volver" />
              </div>
            </div>

            <div className="flex items-center gap-4 lg:gap-6 relative z-[90]">
              <div className="hidden sm:flex items-center mr-2">
                <div className="text-right mr-3">
                  <h1 className="text-white font-bold text-[22px] m-0 leading-tight tracking-wide">
                    BÓRRALO
                  </h1>
                  <p className="text-white/90 italic text-[13px] mt-[2px] m-0">
                    Bórralo te lo compra!!
                  </p>
                </div>
                <div className="bg-white w-[50px] h-[50px] rounded-full overflow-hidden flex justify-center items-center shadow-lg shrink-0">
                  <img
                    src={Logo}
                    alt="Logo"
                    className="w-[40px] h-[40px] object-contain"
                  />
                </div>
              </div>

              <div className="h-10 w-px bg-white/30 hidden sm:block" />

              <div className="relative z-[100]" ref={userMenuRef}>
                <button
                  onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                  className="flex items-center gap-x-2 focus:outline-none p-1.5 rounded-lg hover:bg-white/10 transition-colors cursor-pointer"
                >
                  <span className="font-semibold text-white mr-1 hidden lg:block">
                    {user?.person?.name || "Administrador"}
                  </span>
                  <UserMenuIcon size={28} className="text-white" />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={classNames(
                      "text-white transition-transform duration-200",
                      isUserMenuOpen ? "rotate-180" : "rotate-0",
                    )}
                  >
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>

                {isUserMenuOpen && (
                  <div className="absolute right-0 z-[110] mt-2 w-48 origin-top-right rounded-xl bg-white py-2 shadow-2xl ring-1 ring-black/10 border border-gray-100">
                    <button
                      className="block w-full px-4 py-2.5 text-left font-sans text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors font-medium cursor-pointer"
                      onClick={() => {
                        setIsUserMenuOpen(false);
                        setIsLogoutModalOpen(true);
                      }}
                    >
                      Cerrar sesión
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <SideBar navigation={navigation} toggleSidebar={toggleSidebar} />
      <main className="relative z-0">{!!user && <Outlet />}</main>

      <ConfirmModal
        isOpen={isLogoutModalOpen}
        title="¿Cerrar sesión?"
        message="¿Realmente desea cerrar la sesión activa?"
        confirmText="Aceptar"
        cancelText="Cancelar"
        variant="danger"
        onConfirm={() => navigate("/logout", { replace: true })}
        onClose={() => setIsLogoutModalOpen(false)}
      />
    </div>
  );
};

const SideBar = ({ navigation, toggleSidebar }) => {
  return (
    <div className="desk-sidebar">
      <aside>
        <div className="flex grow flex-col gap-y-3 overflow-y-auto border-r border-gray-200 bg-white px-2 pt-2 pb-6 transition-all duration-300 shadow-lg h-full">
          <li className="menu-item list-none mb-1">
            <button
              type="button"
              className="w-full flex items-center gap-x-3 rounded-xl bg-[#1D3B8B]/10 hover:bg-[#1D3B8B]/20 text-[#1D3B8B] transition-colors font-semibold text-sm cursor-pointer"
              onClick={toggleSidebar}
            >
              <MenuIcon size={22} className="shrink-0 text-[#1D3B8B]" />
              <span className="item-label truncate">Menú principal</span>
            </button>
          </li>

          <nav className="flex flex-1 flex-col">
            <ul className="flex flex-1 flex-col space-y-2">
              {navigation
                .filter((x) => !x.hidden)
                .map((item, index) => (
                  <MenuItem key={index} item={item} />
                ))}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
};

export const MenuItem = ({ item }) => {
  const location = useLocation();
  const [showItems, setShowItems] = useState(false);

  const isActive = useMemo(() => {
    if (!item?.href) {
      const innerPaths = [];
      item?.nested?.map((x) => innerPaths.push(x.href));
      item?.modules?.map((x) => innerPaths.push(x.href));
      return innerPaths.some((x) => {
        if (String(item.href).includes(":")) {
          const currentParts = location.pathname.split("/");
          const pathParts = item?.href?.split("/") || [];
          if (currentParts.length !== pathParts.length) return false;
          return pathParts.every((item, i) => {
            const _current = currentParts[i];
            return pathParts[i].includes(":") ? true : item === _current;
          });
        }
        return location.pathname === x;
      });
    }
    return location.pathname === item?.href;
  });

  const openSidebar = () => {
    const items = document.getElementsByClassName("desk-sidebar");
    if (items.item(0).classList.contains("open")) return;
    for (let key = 0; key < items.length; key++) {
      if (!items.item(key).classList.contains("open")) {
        items.item(key).classList.toggle("open");
      }
    }
    setShowItems(true);
  };

  const IconComponent = item.icon;

  if (!item?.modules?.length)
    return (
      <li className="menu-item" title={item.name}>
        <Link
          to={item.href}
          className={classNames(
            "group flex gap-x-3 rounded-xl items-center leading-6 font-medium transition-all duration-200",
            isActive
              ? "bg-[#1D3B8B]/10 text-[#1D3B8B] shadow-sm font-semibold"
              : "text-gray-600 hover:bg-gray-100 hover:text-[#1D3B8B]",
          )}
        >
          {IconComponent && (
            <IconComponent
              size={22}
              className={classNames(
                "shrink-0 transition-colors duration-200",
                isActive
                  ? "text-[#1D3B8B]"
                  : "text-gray-400 group-hover:text-[#1D3B8B]",
              )}
            />
          )}
          <span>{item.name}</span>
        </Link>
      </li>
    );

  return (
    <li className="menu-item" title={item.name} onClick={openSidebar}>
      <Link
        to={item.modules[0].href}
        className={classNames(
          "group flex gap-x-3 rounded-xl items-center leading-6 font-medium transition-all duration-200",
          isActive
            ? "bg-[#1D3B8B]/10 text-[#1D3B8B] shadow-sm font-semibold"
            : "text-gray-600 hover:bg-gray-100 hover:text-[#1D3B8B]",
        )}
        onClick={() => setShowItems(!showItems)}
      >
        {IconComponent && (
          <IconComponent
            size={22}
            className={classNames(
              "shrink-0 transition-colors duration-200",
              isActive
                ? "text-[#1D3B8B]"
                : "text-gray-400 group-hover:text-[#1D3B8B]",
            )}
          />
        )}
        <span className="item-label flex-1">{item.name}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          className={classNames(
            "transition-transform duration-200",
            showItems ? "rotate-90 text-[#1D3B8B]" : "rotate-0 text-gray-400",
          )}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </Link>

      {showItems && (
        <ul className="pl-11 space-y-2 mt-2">
          {item?.modules?.map((subItem, subIdx) => {
            let isSubActive = false;
            if (String(subItem.href).includes(":")) {
              const currentParts = location.pathname.split("/");
              const pathParts = subItem?.href?.split("/") || [];
              if (currentParts.length === pathParts.length) {
                isSubActive = pathParts.every((part, i) =>
                  part.includes(":") ? true : part === currentParts[i],
                );
              }
            } else {
              isSubActive = location.pathname === subItem?.href;
            }

            if (!subItem?.modules?.length) {
              const SubIcon = subItem.icon;
              return (
                <li key={subIdx} title={subItem.name}>
                  <Link
                    to={subItem?.href}
                    className={classNames(
                      "group flex gap-x-3 rounded-lg p-2.5 items-center leading-5 font-medium transition-all duration-200",
                      isSubActive
                        ? "text-[#1D3B8B] bg-[#1D3B8B]/10 font-semibold"
                        : "text-gray-500 hover:text-[#1D3B8B] hover:bg-gray-50",
                    )}
                  >
                    {SubIcon && (
                      <SubIcon
                        size={20}
                        className={classNames(
                          "shrink-0",
                          isSubActive
                            ? "text-[#1D3B8B]"
                            : "text-gray-400 group-hover:text-[#1D3B8B]",
                        )}
                      />
                    )}
                    <span>{subItem.name}</span>
                  </Link>
                </li>
              );
            }
            return <MenuItem key={"sub" + subIdx} item={subItem} />;
          })}
        </ul>
      )}
    </li>
  );
};

export default Layout;
